import React, { useEffect, useState, useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { UserContext } from "./context/UserContext";
import "./App.css";
import AppNavbar from "./components/AppNavbar";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import ProfilePage from "./pages/ProfilePage";
import Explore from "./pages/Explore";
import Discussions from "./pages/DiscussionsPage";
import {Contact} from "./pages/Contact";

import InvitationsRequestsPage from "./pages/InvitationsRequestsPage";
function App() {
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      setUser(loggedInUser);
    } else {
      setUser(null);
    }
  }, [user]);

  return (
    <div className="App">
      {/* <Router> */}
      <AppNavbar />
      <Routes>
        <Route path="/contact" exact element={<Contact />} />
        <Route path="/forum" exact element={<Discussions />} />
        <Route path="/home" exact element={<HomePage />} />
        <Route path="/signup" exact element={<SignupPage />} />
        <Route path="/" exact element={<LoginPage />} />
        <Route path="/profile" exact element={<ProfilePage />} />
        <Route path="/explore" exact element={<Explore />} />
        
        <Route
          path="/invitations-requests"
          exact
          element={<InvitationsRequestsPage />}
        />

        <Route path="*" exact element={<LoginPage />} />
      </Routes>
      {/* </Router> */}
    </div>
  );
}

export default App;
